import React from 'react';

import { ThemeProvider } from '@change/ds-core-ui/next';

import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { ContributeSection } from './components/ContributeSection';
import { HeroSection } from './components/HeroSection';
import { HeroSection as HeroSectionExperiment } from './components/HeroSectionExperiment';
import { HowToSection } from './components/HowToSection';
import { LocalSection } from './components/LocalSection';
import { TrendingSection } from './components/TrendingSection';
import { usePageBody } from './hooks/usePageBody';

export function PageBody(): React.JSX.Element {
	const { data } = usePageBody();
	return (
		<ThemeProvider>
			{!data.experiments.starfishHomepageToSapDraftV1.variation.includes('control') ? (
				<HeroSectionExperiment />
			) : (
				<HeroSection />
			)}

			<HowToSection />

			<div className="container space-y-16 py-6 md:space-y-28 md:py-[93px]">
				<ClientRender placeholder={<Loader size="m" my={256} mx="auto" />}>
					<LocalSection />
				</ClientRender>

				<TrendingSection />

				<ContributeSection />
			</div>
		</ThemeProvider>
	);
}
